import { ssoApi } from "@sso/apis";
import { SliceKeys } from "@sso/constant";

import APIAccountReducer from "./apiAccount";
import AuthReducer from "./auth";
import BannedIPReducer from "./bannedIP";
import BilledOperationReducer from "./billedOperations";
import DialogReducer from "./dialog";
import DrawerReducer from "./drawer";
import LicenceReducer from "./licence";
import OrderReducer from "./order";
import OrganisationReducer from "./organisation";
import PricingReducer from "./pricing";
import ProductReducer from "./product";
import SnackbarReducer from "./snackbar";
import SoftwareLicenceReducer from "./softwareLicence";
import TraccUsageReducer from "./traccUsage";
import UserReducer from "./user";

export const appReducers = {
  [SliceKeys.DRAWER]: DrawerReducer,
  [SliceKeys.SNACKBAR]: SnackbarReducer,
  [SliceKeys.AUTH]: AuthReducer,
  [SliceKeys.DIALOG]: DialogReducer,
  [SliceKeys.ORGANISATION]: OrganisationReducer,
  [SliceKeys.USER]: UserReducer,
  [SliceKeys.BANNED_IP]: BannedIPReducer,
  [SliceKeys.API_Account]: APIAccountReducer,
  [SliceKeys.LICENCE]: LicenceReducer,
  [SliceKeys.PRODUCT]: ProductReducer,
  [SliceKeys.SOFTWARE_LICENCE]: SoftwareLicenceReducer,
  [SliceKeys.PRICING]: PricingReducer,
  [SliceKeys.ORDER]: OrderReducer,
  [SliceKeys.TRACC_Usage]: TraccUsageReducer,
  [SliceKeys.BILLED_OPERATION]: BilledOperationReducer,
  [ssoApi.reducerPath]: ssoApi.reducer,
};
